import HeatmapLoader from '../components/HeatmapLoader';
import { connect } from 'react-redux';
import { redux } from '../api';

const { setAiHeatmapData } = redux.actions;

const mapStateToProps = state => {
  const imageData = state.ui.imageData;
  let imageReady = false;
  Object.keys(imageData).forEach(k => {
    if (imageData[k].image) imageReady = true;
  });

  return {
    imageReady,
    viewportData: state.viewports.viewportSpecificData,
    context: state.ui.heatmapContext,
    resource: state.api.resource,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHeatmapData: data => dispatch(setAiHeatmapData(data)),
  };
};

const ConnectedHeatmapLoader = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeatmapLoader);
export default ConnectedHeatmapLoader;
